<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ item?.id ? $t('stockCategoryEditModalTitle') : $t('stockCategoryCreateModalTitle') }}</div>
    </template>
    <Spinner v-if="dataIsSending" :overlayStyle="'height: 80px'"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">
        <div class="p-float-label">
          <InputText id="warehouseCategory_name" :class="{'p-invalid' : submitted && !itemData.name}" v-model.trim="itemData.name" autocomplete="off"/>
          <label for="warehouseCategory_name">{{ $t('Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !itemData.name">{{ $t('Required field') }}</small>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" :disabled="disableSaveButton" icon="pi pi-check" class="p-button-text" @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ showErrorsMixins ],
  emits: ['close', 'update-items'],
  name: 'WarehouseCategoryModal',
  props: {
    item: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataIsSending: false,
      disableSaveButton: false,
      itemData: {},
      submitted: false,
      settings
    }
  },
  watch: {
    item(value) {
      // if (!value) return
      // this.itemData = { ...value }
      this.itemData = value ? { ...value } : {}
    },
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
      }
    },
  },
  methods: {
    async saveItem() {
      this.submitted = true
      if (!this.itemData.name) {
        return false
      }
      this.disableSaveButton = true
      this.dataIsSending = true

      const warehouseCategory = {
        id: this.itemData.id ?? null,
        name: this.itemData.name ?? null,
        sorting: this.itemData.sorting ?? null,
      }

      if (this.itemData.id) {
        try {
          const { status, data } = await httpClient.post(`warehouse/update-category`, warehouseCategory)
          if (status === 200 && data?.success) {
            this.$emit('update-items', this.itemData.id)
            this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: this.settings.toastLife});
            this.close()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      } else {
        try {
          const { status, data } = await httpClient.post(`warehouse/create-category`, warehouseCategory)
          if (status === 201 && data?.success) {
            this.itemData.id = data?.id
            warehouseCategory.id = data?.id
            this.$emit('update-items', this.itemData.id)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: this.settings.toastLife});
            this.close()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {width: '95%', maxWidth: '420px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {width: '420px'}
      } else {
        return {width: '420px'}
      }
    },
  },

}
</script>